import { Trans, useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'
import { Main } from '../../components'

const SheetLinkNotFound = () => {
  const { t } = useTranslation()
  const { pathname } = useLocation()

  const [, , region, realm, guild, team] = pathname.split('/')

  const settingsPath =
    region && realm && guild && team
      ? `/guild/${region}/${realm}/${guild}/teams/${team}/settings#team`
      : null

  return (
    <Main>
      <div className='text-center mt-16'>
        <h3>{t('errors.sheet_link_not_found')}</h3>
        <p>
          <Trans
            i18nKey='errors.sheet_link_not_found_description'
            components={[
              settingsPath ? (
                <Link
                  to={settingsPath}
                  className='text-primary hover:text-primary/90'
                />
              ) : (
                <span />
              ),
            ]}
          />
        </p>
      </div>
    </Main>
  )
}

export default SheetLinkNotFound
